import LabelProvider from "core/components/label/LabelProvider";
import { filters } from "common/Labels/Refine";
import { Messages } from "common/Labels/Messages";

export default LabelProvider.create({

	...Messages,
	...filters

});



// WEBPACK FOOTER //
// ./src/panels/announcements/Announcements.labels.ts